import React from 'react';
import { Divider, Flex, Typography } from 'antd';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import { formatCoverageValue } from 'Utils';
import { ListCoverages } from 'Pages/QuotationsComparatorPage/components/ListCoverages';
import { ViewQuotationPdfButton } from '@shared/components/buttons/ViewQuotationPdfButton';

import './index.css';

const { Text, Title } = Typography;

const ModalDetails = (props) => {
  const {
    showModal,
    handleCancel,
    packagesDetailShow,
    listCoverages,
    listAssists,
    insuranceCarrier,
  } = props;

  const external_session = localStorage.getItem('external_session') === "true" || false;

  if (!showModal || !packagesDetailShow) return null;

  const payment = packagesDetailShow.payments.find((paymentIterator) => paymentIterator.id === 'ANUAL') ?? {};
  return (
    <div role="dialog" className="modalCustom01 modalCustom02">
      <div style={{ opacity: 1, transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' }} className="Backdrop01"> </div>
      <div tabIndex="-1" style={{ opacity: 1, transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' }} className="modalCustom03 modalCustom04">
        <div className="modalCustom05 modalCustom06 modalCustom07 content01 paper01 paper02 paper03">
          <button onClick={handleCancel} type="button" tabIndex="0" className="close-button-icon">
            <FontAwesomeIcon icon={faXmark} />
          </button>
          <div className="container-header-modal">
            <div>
              <div></div>
              <div className="paper03 c01707 paper04">
                <div className="content-header">
                  <Flex align='center' flex={1}>
                    <div className="package-img">
                      <div className="package-img-item">
                        <img loading="lazy" className="package-img-img" src={insuranceCarrier && insuranceCarrier.logo_url} alt="seguro vehiculo" height="30" />
                        <img className="package-img-pre" loading="lazy" alt="" role="presentation" src="https://res.cloudinary.com/compara/image/upload/v1569616070/assets/card/shadow.svg" width="118" height="7"></img>
                      </div>
                    </div>
                    <div>
                      <Title level={5} style={{ margin: 0 }}>
                        {packagesDetailShow.package_detail} <Text type='secondary'>#{packagesDetailShow.number}</Text>
                      </Title>
                      <div className="grid01 grid02 grid03">
                        <div className="grid04">
                          <div style={{ textAlignc: 'center' }}>
                            <span className="payment-text">Pago contado</span>
                            <span className="payment-value">&nbsp;{formatCoverageValue(payment.value)} </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {!external_session && (packagesDetailShow?.complete_public_url ? (
                      <div style={{ textAlign: 'center', flex: 1 }}>
                        {/* <a href={packagesDetailShow?.complete_public_url} target="_blank">
                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: '40px', color: '#ff4d4d', cursor: 'pointer' }} />
                          <p>PDF</p>
                        </a> */}
                        <ViewQuotationPdfButton url={packagesDetailShow?.complete_public_url} style={{ fontSize: '3em' }} />
                      </div>
                    ) : '')}
                  </Flex>
                </div>
              </div>
            </div>
          </div>
          <div className="container-content-modal">
            <Text strong>Seguros para Vehículos</Text>
            <Divider size='middle' style={{ marginTop: 4 }} />
            <ListCoverages insurancePackage={packagesDetailShow} coverages={listCoverages} assists={listAssists} />
            {/* {listCoverages.map((coverage, key) => (
              <div key={key} className="container-content-modal-item">
                <div className="container-content-modal-item01">
                  <FontAwesomeIcon icon={faCheck} style={{ color: 'rgb(106, 136, 254' }} />
                </div>
                <div className="container-content-modal-item02">
                  <p className="typography01 typography02">
                    <span>{coverage.name}</span>: {formatCoverageValue(coverage.insured_value)}</p>
                </div>
              </div>
            ))} */}
          </div>
        </div>
      </div>
    </div>
  );
};

ModalDetails.defaultProps = {
  packagesDetailShow: null,
};

ModalDetails.propTypes = {
  showModal: PropTypes.bool.isRequired,
  packagesDetailShow: PropTypes.object,
  listCoverages: PropTypes.array.isRequired,
  listAssists: PropTypes.array.isRequired,
};

export default ModalDetails;
